module.exports = __webpack_public_path__ + "img/Quiet-Cove-014.632e5f46.jpg";